import routes from '../../../../public/js/laroute';
import Vue from 'vue';

class BaseRepository {

    constructor() {
        this.routes = routes;
        this.route = routes.route;
    }

    /**
     * Perform a get request
     *
     * @param {String} url
     * @param {Object} data
     * @param {Object} headers
     *
     * @returns {Promise}
     */
    get(url, data = {}, headers = {}) {
        return this.request('get', url, data, headers);
    }

    /**
     * Perform a patch request
     *
     * @param {String} url
     * @param {Object} data
     * @param {Object} headers
     *
     * @returns {Promise}
     */
    patch(url, data = {}, headers = {}) {
        return this.request('patch', url, data, headers);
    }

    /**
     * Perform a put request
     *
     * @param {String} url
     * @param {Object} data
     * @param {Object} headers
     *
     * @returns {Promise}
     */
    put(url, data = {}, headers = {}) {
        return this.request('put', url, data, headers);
    }

    /**
     * Perform a post request
     *
     * @param {String} url
     * @param {Object} data
     * @param {Object} headers
     *
     * @returns {Promise}
     */
    post(url, data = {}, headers = {}) {
        return this.request('post', url, data, headers);
    }

    /**
     * Perform a delete request
     *
     * @param {String} url
     * @param {Object} data
     * @param {Object} headers
     *
     * @returns {Promise}
     */
    delete(url, data = {}, headers = {}) {
        return this.request('delete', url, data, headers);
    }

    /**
     * Make the standard http request - we make the requests here
     * so that we can switch out the XHR client easily in the future
     *
     * @param {String} method - http request method
     * @param {String} url - url to request
     * @param {Object} data - data to submit
     * @param {Object} headers - headers to attach to the request
     * @param {Object} config - request config
     *
     * @returns {Promise}
     */
    request(method, url, data = {}, headers = {}, config = {}) {
        let response;

        switch (method) {
            case 'post':
            case 'put':
            case 'patch':
                // These requests take the data as the
                // second parameter rather than in the config
                response = Vue.http[method](url, data, { headers, ...config });
                break;
            default:
                response = Vue.http[method](url, { headers, params: data, ...config });
                break;
        }

        return response;
    }

    /**
     * Normalise the response and return just the data
     *
     * @param response
     */
    normaliseResponse({ data }) {
        return data;
    }

    /**
     * Return the header that's detected by the http interceptor to tell
     * it that the request should use the auth cookie
     *
     * @returns {{requiresAuth: string}}
     */
    authHeader() {
        return {
            requiresAuth: 'yes',
        }
    }
}

export default BaseRepository;
